import * as React from 'react';
import { Text } from '../../../typography';
import { classNames } from '@wix/answers-lib';
import { Icon } from '../../../../../primitives/icon/icon';
import { mediumX, checkInline } from '../../../../../icons/processed';
import { namespacedClassnames } from '../../../../../common/namespace-classes';
export var inlineControlKey = namespacedClassnames('inline-control');
export var InlineControl = function (props) {
    var onClear = props.onClear, onConfirm = props.onConfirm, onCancel = props.onCancel, disabledClear = props.disabledClear, disabledConfirm = props.disabledConfirm, disabledCancel = props.disabledCancel, clearText = props.clearText, hideClear = props.hideClear, hideCancelConfirm = props.hideCancelConfirm;
    var clearButtonClassName = classNames('clear-button', { disabled: disabledClear });
    var confirmButtonClassName = classNames('confirm-button', { disabled: disabledConfirm });
    var cancelButtonClassName = classNames('cancel-button', { disabled: disabledCancel });
    var clearButton = !hideClear
        ? (React.createElement("div", { className: clearButtonClassName, onMouseDown: onClear },
            React.createElement(Text, { type: 'tsm', color: 't60' }, clearText)))
        : null;
    var cancelConfirmButtons = !hideCancelConfirm ?
        React.createElement("div", { className: 'right-buttons' },
            React.createElement("div", { className: cancelButtonClassName, onMouseDown: onCancel },
                React.createElement(Icon, { icon: mediumX })),
            React.createElement("div", { className: 'divider' }),
            React.createElement("div", { className: confirmButtonClassName, onMouseDown: onConfirm },
                React.createElement(Icon, { icon: checkInline })))
        : null;
    return (React.createElement("div", { className: inlineControlKey },
        clearButton,
        cancelConfirmButtons));
};
//# sourceMappingURL=index.js.map